import {Action, Dispatch, Middleware} from "@reduxjs/toolkit";

import {fetchFeatureFlags} from "@/store/slices/featuresSlice";

export const eventListenerMiddleware: Middleware<object, any, Dispatch<Action>> = (store) => (next) => (action) => {
  const result = next(action);

  if ((action as Action).type === "auth/tokenReceived") {
    store.dispatch(fetchFeatureFlags() as unknown as Action);
  }

  return result;
};
